import ManageUtilityPlanRoot from './Plan'

export default function ManageUtilityPlan() {
  return <ManageUtilityPlanRoot />
}
